import { useEffect } from 'react';
import { useEditableContextOptional } from '../../editableContext';
import { readActiveEditableSlot } from './commitActiveEditor';

/**
 * Prop-driven inline cells keep local `isEditing` for legacy Table compatibility
 * while also writing to the shared OptimizedTable slot. When another cell's
 * mousedown handoff clears the shared slot (DL-60610), local state must drop too
 * or the outgoing popup stays mounted.
 */
export const usePropDrivenInlineEditSync = (
  rowIndex: number,
  columnId: string,
  setIsEditing: (editing: boolean) => void
): void => {
  const editableCtx = useEditableContextOptional();
  const editableState = editableCtx?.editableState;

  useEffect(() => {
    if (!editableCtx) return;
    const slot = readActiveEditableSlot(editableCtx);
    const ownsSlot = slot?.rowIndex === rowIndex && slot?.columnId === columnId;
    if (!ownsSlot) {
      setIsEditing(false);
    }
  }, [editableCtx, editableState, rowIndex, columnId, setIsEditing]);
};
